export const prefixRoute = (route: string, prefix: string): string => {
  if (prefix === '' || prefix.length === 0) {
    return route
  }

  if (route.startsWith(prefix + '/') || route === prefix) {
    return route
  }

  const normalizedPrefix = prefix.startsWith('/') ? prefix : `/${prefix}`
  const normalizedPath = route.startsWith('/') ? route : `/${route}`

  return normalizedPrefix + normalizedPath
}
